module.exports = __webpack_public_path__ + "static/img/loadingS.c39f118.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build08/assets/images/common/loadingS.png
// module id = l8LB
// module chunks = 43